export class Languages  {

	name: string;
	code: string;
	isSelected: boolean = false;
}
